import { Link } from 'react-router-dom';
import { User, Flame, Star } from 'lucide-react';
import useAuthStore from '../../store/authStore';

export default function AppHeader() {
  const { student } = useAuthStore();

  // Default values if no student is provided (for demo)
  const displayStudent = student || {
    name: 'Student',
    avatar: 'seedling',
    total_points: 1950,
    streak_days: 8,
  };

  return (
    <header className="fixed top-0 left-0 right-0 z-40 glass border-b border-white/20">
      <div className="max-w-lg mx-auto px-4">
        <div className="flex items-center justify-between h-14">
          {/* Logo */}
          <Link to="/app" className="flex items-center gap-2">
            <img
              src="/images/leafscape - logo.png"
              alt="Leafscape"
              className="h-8 w-auto"
              onError={(e) => {
                e.target.style.display = 'none';
              }}
            />
            <span className="font-heading text-lg text-leaf-800 hidden sm:block">
              Leafscape
            </span>
          </Link>

          {/* Stats */}
          <div className="flex items-center gap-4">
            {/* Streak */}
            <div className="flex items-center gap-1 text-orange-500">
              <Flame size={18} className="fill-current" />
              <span className="font-semibold text-sm">{displayStudent.streak_days}</span>
            </div>

            {/* Points */}
            <div className="flex items-center gap-1 text-sunshine-500">
              <Star size={18} className="fill-current" />
              <span className="font-semibold text-sm">{displayStudent.total_points}</span>
            </div>

            {/* Profile */}
            <Link
              to="/app/profile"
              className="w-9 h-9 rounded-full bg-leaf-100 flex items-center justify-center
                         hover:bg-leaf-200 transition-colors"
            >
              <User size={20} className="text-leaf-700" />
            </Link>
          </div>
        </div>
      </div>
    </header>
  );
}
